import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient,) { }

  postFile(fileToUpload: File){
    const endpoint = 'http://aws.fractalite.com/s3/upload';
    const formData: FormData = new FormData();
    formData.append('files', fileToUpload, fileToUpload.name);
    return this.http.post(endpoint, formData, { headers: {} });
  }

  deleteFile(fileName:string){
      const endpoint = 'http://aws.fractalite.com/s3/delete?fileName='+fileName;
      return this.http.delete(endpoint);
  }
}
